import {formatedPrice, getDeclension} from "../utils/common";

export /**
 *
 *  @param {number} id - Идентификатор карточки,
 *  @param {string} name - Наименование товара,
 *  @param {string} brand - Наименование бренда,
 *  @param {string} href - Ссылка на товар,
 *  @param {boolean} isFavorite - Добавлен ли товар в избранное,
 *  @param {number} price - Цена товара,
 *  @param {number | null} oldPrice - Старая цена товара,
 *  @param {number} discountPercent - Размер скидки,
 *  @param {string | null} videoSrc - Путь к видеофайлу,
 *  @param {object} imagesData - Объект с данными изображений
 * @return {string}
 */
const getProductCardTemplate = ({id, name, brand, href, isFavorite, price, oldPrice, discountPercent, videoSrc, imagesData}, index) => {
  return `<div class="product-card" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
            <meta content="${index}" itemprop="position">
              <button class="product-card__add-favorite add-favorite add-favorite--card js-add-favorite ${
                isFavorite ? "add-favorite--pressed" : ""
              }" data-favorite-url="/actions/ajax-product-action/add-product-favorite?productId=${id}" type="button" aria-label="Добавить в избранное">
                <svg width="22" height="20">
                  <use xlink:href="/img/sprite.svg#icon-heart"></use>
                </svg>
              </button>
              <a href="${href}" class="product-card__wrap">
                ${getImgWrapTemplate(videoSrc, href, imagesData, discountPercent)}

                <div class="product-card__content">
                  <div class="product-card__price-wrap">
                  ${
                    price
                      ? `<p class="product-card__price">${formatedPrice(price)}&nbsp;₽</p>`
                      : '<p class="product-card__price product-card__price--small">Цена по&nbsp;запросу</p>'
                  }
                  ${oldPrice ? `<p class="product-card__discount"><span>${formatedPrice(oldPrice)}  ₽</span></p>` : ""}
                  </div>

                  <p class="product-card__text">${name}</p>
                  <meta itemprop="name" content="${name}">
                  <p class="product-card__text product-card__text--gray">${brand}</p>
                </div>
              </a>
            </div>`;
};

export /**
 *
 *  @param {number} id - Идентификатор карточки,
 *  @param {string} name - Наименование товара,
 *  @param {string} brand - Наименование бренда,
 *  @param {string} href - Ссылка на товар,
 *  @param {boolean} isFavorite - Добавлен ли товар в избранное,
 *  @param {number} price - Цена товара,
 *  @param {number | null} oldPrice - Старая цена товара,
 *  @param {number} discountPercent - Размер скидки,
 *  @param {object} status - Статус товара,
 *  @param {number} variation - Кол-во вариантов этого товара,
 *  @param {number} cartCount - Кол-во этого товара добавлено в корзину,
 *  @param {string} size - Размер товара,
 *  @param {string} vendorCode - Артикул товара,
 *  @param {object} imagesData - Объект с данными изображений
 * @return {string}
 */ const getProductCardOldTemplate = (
  {id, name, brand, href, isFavorite, price, oldPrice, discountPercent, status, imagesData, isCollection},
  index,
) => {
  return `<div class="catalog__cards-item card js-card" data-id="${id}" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem">
    <meta content="${index}" itemprop="position">
    <button class="card__heart-button add-favorite add-favorite--card ${
      isFavorite ? "add-favorite--pressed" : ""
    } js-add-favorite" data-favorite-url="/actions/ajax-product-action/add-product-favorite?productId=${id}" type="button" aria-label="Добавить в избранное">
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.7286 15.5171L12.7281 15.5175C12.2047 15.931 11.7221 16.3063 11.2525 16.5807C10.7827 16.8553 10.3731 16.9999 10 16.9999C9.62698 16.9999 9.2175 16.8551 8.74754 16.5805C8.27775 16.3059 7.79514 15.9309 7.27148 15.5182C6.98456 15.2919 6.69091 15.0655 6.39426 14.8368C5.13929 13.8693 3.83068 12.8605 2.75159 11.6455C1.43455 10.1626 0.5 8.41232 0.5 6.13689C0.5 3.89244 1.76857 1.99725 3.52036 1.19651C5.24062 0.410189 7.51768 0.642549 9.63973 2.8476L10 3.22196L10.3603 2.8476C12.4823 0.642608 14.7593 0.410683 16.4796 1.19736C18.2314 1.99847 19.5 3.89396 19.5 6.13789C19.5 8.41285 18.5657 10.1631 17.2488 11.6459C16.1679 12.8629 14.8565 13.8731 13.5992 14.8415C13.3048 15.0683 13.0134 15.2928 12.7286 15.5171Z"
          fill="white" stroke="black" />
      </svg>
    </button>
    <a href="${href}" class="card__wrapper">
      <div class="card__img-box js-item-slider">
          ${isCollection ? `<span class="card__percent card__percent--purple">NEW</span>` : ""}
          ${discountPercent ? `<span class="card__percent">-${discountPercent}%</span>` : ""}
          <div class="card__tags">
            ${
              status === "unavailable"
                ? '<p class="card__tag" style="color: #a2024f; border-color: #a2024f;" aria-label="Недоступен к заказу"></p>'
                : ""
            }
          </div>
          <picture class="card__picture js-item-slider-image">
                ${imagesData.mobileWebpSrc ? `<source media="(max-width: 767px)" srcset="${imagesData.mobileWebpSrc}" type="image/webp">` : ""}
                ${imagesData.mobileSrc ? `<source media="(max-width: 767px)" srcset="${imagesData.mobileSrc}">` : ""}
                ${imagesData.webpSrc ? `<source srcset="${imagesData.webpSrc}" type="image/webp">` : ""}
                <img src="${imagesData.src}" alt="" width="341" height="307" class="card__picture-img js-card-img">
              </picture>
          <link itemprop="image" property="image" href="https://tezis-shop.ru/${imagesData.src}" content="https://tezis-shop.ru/${imagesData.src}">
          <link itemprop="url" href="${href}">
          <div class="card__slider-controls">
          ${imagesData.slides
            .map(
              (image) =>
                `<div class="card__slider-control js-item-slider-control" data-src="${image.src}" ${
                  image.webpSrc ? `data-webp-src="${image.webpSrc}"` : ""
                } ></div>`,
            )
            .join("")}

              <div class="card__slider-pagination">
                ${imagesData.slides
                  .map((slide, index) => `<div class="card__slider-pagination-dot js-item-slider-dot ${index === 0 ? "active" : ""}"></div>`)
                  .join("")}
              </div>
          </div>
      </div>
      <div class="card__info">
          <div class="card__info-top">
            <div class="card__info-price price">
            ${
              oldPrice
                ? `<p class="price__discount">
                  <del class="price__discount-cost"><span class="js-card-old-price" data-price="${oldPrice}">${formatedPrice(oldPrice)}</span>
                      <span class="rouble">₽</span></del>
              </p>`
                : ""
            }

            ${
              price
                ? `<p class="price__current-cost"><span class="js-card-price" data-price="${price}">${formatedPrice(
                    price,
                  )}</span> <span class="rouble">₽</span></p>`
                : '<p class="price__current-request">Цена по&nbsp;запросу</p>'
            }
            </div>

            <meta itemprop="name" content="${name}">
            ${
              status !== "unavailable"
                ? `
              <p class="card__status card__status--${status}"></p>`
                : ""
            }
          </div>
            <p class="card__info-name js-card-name">${name}</p>
            <p class="card__info-brand js-card-brand">${brand}</p>
      </div>
    </a>
</div>`;
};

/**
 *
 * @param {string | null} videoSrc - Путь к видеофайлу
 * @param {string} src - Путь к изображению
 * @param {string} webpSrc - Путь к изображению webp
 * @param {string} mobileSrc - Путь к изображению моб версии
 * @param {string} mobileWebpSrc - Путь к изображению моб версии webp
 * @param {Array} slides - Массив с данными других изображений товара
 * @return {string}
 */
const getImgWrapTemplate = (videoSrc, href, {src, webpSrc, mobileSrc, mobileWebpSrc, slides}, discountPercent) => {
  return `<div class="product-card__img-wrap ${videoSrc ? "" : "js-item-slider"}">
            ${discountPercent ? `<span class="product-card__percent">-${discountPercent}%</span>` : ""}
            <link itemprop="image" property="image" href="https://tezis-shop.ru/${src}" content="https://tezis-shop.ru/${src}">
            <link itemprop="url" href="${href}">
            <picture class="product-card__picture ${videoSrc ? "" : "js-item-slider-image"}">
              ${mobileWebpSrc ? `<source media="(max-width: 767px)" srcset="${mobileWebpSrc}" type="image/webp">` : ""}
              ${mobileSrc ? `<source media="(max-width: 767px)" srcset="${mobileSrc}">` : ""}
              ${webpSrc ? `<source srcset="${webpSrc}" type="image/webp">` : ""}
              <img src="${src}" alt="" width="341" height="500" class="product-card__img">
            </picture>
            ${
              videoSrc
                ? '<video class="product-card__video js-item-video" src="/video/product-video.mp4" muted=""></video>'
                : `<div class="product-card__slider-control slider-control">${slides
                    .map(
                      (image) =>
                        `<div class="slider-control__item js-item-slider-control" data-src="${image.src}" ${
                          image.webpSrc ? `data-webp-src="${image.webpSrc}"` : ""
                        } ></div>`,
                    )
                    .join("")}
                    <div class="product-card__pagination slider-control__pagination">
                    ${slides
                      .map((slide, index) => `<div class="slider-control__bullet js-item-slider-dot ${index === 0 ? "active" : ""}"></div>`)
                      .join("")}
                    </div>
                  </div>`
            }
                </div>`;
};
